<div id="app">
  <app-spinner></app-spinner>
  
  <app-main-page></app-main-page>
</div>
